import { CHAT_AGGREGATE_NAMESPACE } from 'cpool-constants';
import { v5 as uuidv5 } from 'uuid';

/**
 * Deterministically derives the Chat aggregate id for a WhatsApp chat from the
 * Meta phone number id and the customer's identity (phone number, or — from June 2026 — a BSUID).
 * Same inputs always produce the same chatId, so inbound webhooks and outbound sends
 * can address the correct aggregate without needing a lookup table.
 */
export function deriveChatId(phoneNumberId: string, customerIdentity: string): string {
    return uuidv5(`${phoneNumberId}:${customerIdentity}`, CHAT_AGGREGATE_NAMESPACE);
}
